module.exports = __webpack_public_path__ + "img/iMediaTracker.1fe50d68.png";